/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { fg } from '@atlaskit/platform-feature-flags';

import {
	ResizableNativeEmbedCoordinator,
	type ResizableNativeEmbedCoordinatorProps,
} from './ResizableNativeEmbedCoordinator';

export const resizerNextTestId = 'nativeEmbed.resizerNext.testid';

export type ResizableNativeEmbedProps = ResizableNativeEmbedCoordinatorProps;

export const ResizableNativeEmbed = (props: ResizableNativeEmbedProps): JSX.Element | null => {
	const editorViewMode = useSharedPluginStateWithSelector(
		props.pluginInjectionApi,
		['editorViewMode'],
		(states) => states.editorViewModeState?.mode,
	);
	if (fg('cc-native-embed-resize-refactor')) {
		return null;
	}

	if (props.disabled || editorViewMode === 'view') {
		return null;
	}

	// eslint-disable-next-line react/jsx-props-no-spreading -- thin FG-switch wrapper
	return <ResizableNativeEmbedCoordinator {...props} />;
};
